import app from "../_app";

const popups = [...document.querySelectorAll('.js-popup')];

popups.map(popup => {
    const popupKey = popup.dataset.key;

    let triggers = [...document.querySelectorAll(`.js-popup-trigger[data-key="${popupKey}"]`)];
    const closeAllTriggers = [...document.querySelectorAll(`.js-popup-trigger-close-all`)];

    const closeAllPopups = () => {
        popups.map(p => {
            p.removeAttribute('data-open');
            app.unlockBody();

            if (addToCartForm) {
                addToCartForm.removeAttribute('data-direct');
            }
        });
    }
    const reinitTriggersHandler = () => {
        triggers.map(trigger => trigger.removeEventListener('click', togglePopupHandler))
        triggers = [...document.querySelectorAll(`.js-popup-trigger[data-key="${popupKey}"]`)];
        triggers.map(trigger => trigger.addEventListener('click', togglePopupHandler));
    }

    const togglePopupHandler = () => {
        if (popup.hasAttribute('data-open')) {
            popup.removeAttribute('data-open');
            app.unlockBody();

        } else {
            app.lockBody();
            popup.setAttribute('data-open', '');
        }
    };

    triggers.map(trigger => trigger.addEventListener('click', togglePopupHandler));
    closeAllTriggers.map(closeAllTrigger => closeAllTrigger.addEventListener('click', closeAllPopups));

    window.addEventListener(`popup.toggle.${popupKey}`, togglePopupHandler);
    window.addEventListener('popup.reinit-triggers', reinitTriggersHandler);
});




